/**
 * Featured collection carousel – image carousel with heading + arrows.
 * Depends on theme.js exposing window.Shopify.theme.sections.registerSection, loadSection, and helpers.
 */
(function () {
  'use strict';

  var api = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
  if (!api || !api.registerSection || !api.loadSection || !api.helpers) {
    return;
  }

  var register = api.registerSection;
  var load = api.loadSection;
  var h = api.helpers;

  var selectors = {
    sliderContainer: '.featured-collection-carousel__content.carousel',
    arrowsWrapper: '.featured-collection-carousel__arrows-wrapper',
    slide: '.featured-collection-carousel__slide'
  };

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 719px)').matches;
  }

  var sectionImpl = {
    onLoad: function () {
      this.carousel = null;
      this.events = [];

      var dataset = this.container.dataset;
      this._enableSliderMobile = dataset.enableSliderMobile === 'true';
      this._columns = parseInt(dataset.columns, 10) || 4;
      var mobileColumnsRaw = (dataset.mobileColumns || '1.5').trim();
      this._mobilePerView = mobileColumnsRaw === '1.5' ? 1.5 : parseInt(mobileColumnsRaw, 10) || 1.5;

      this._container = h.queryOne(selectors.sliderContainer, this.container);
      if (!this._container) return;

      var arrowsWrapper = h.queryOne(selectors.arrowsWrapper, this.container);
      this._nextButton = arrowsWrapper ? h.queryOne('[data-next]', arrowsWrapper) : null;
      this._prevButton = arrowsWrapper ? h.queryOne('[data-prev]', arrowsWrapper) : null;

      this._evalCarousel();

      var self = this;
      this._resizeHandler = function () { self._evalCarousel(); };
      window.addEventListener('resize', this._resizeHandler);

      if (h.shouldAnimate(this.container)) {
        this.animateListSlider = h.animateListSlider(this.container);
      }
    },

    _shouldHaveCarousel: function () {
      if (isMobileViewport()) {
        return this._enableSliderMobile;
      }
      return true;
    },

    _evalCarousel: function () {
      var shouldInit = this._shouldHaveCarousel();

      if (shouldInit && !this.carousel) {
        this._initCarousel();
      } else if (!shouldInit && this.carousel) {
        this._destroyCarousel();
      }
    },

    _initCarousel: function () {
      var columns = this._columns;
      var slidesCount = this._container.querySelectorAll(selectors.slide).length;
      var hasDesktopPeek = slidesCount >= 4;
      var slidesPerViewDesktop = hasDesktopPeek ? 3.12 : Math.min(columns, slidesCount || columns);

      this.carousel = h.Carousel(this._container, {
        slidesPerView: this._mobilePerView,
        spaceBetween: 13,
        watchOverflow: true,
        navigation: {
          nextEl: this._nextButton,
          prevEl: this._prevButton
        },
        breakpoints: {
          720: {
            spaceBetween: 17,
            slidesPerView: slidesPerViewDesktop
          },
          1200: {
            spaceBetween: 25,
            slidesPerView: slidesPerViewDesktop
          }
        }
      });
    },

    _destroyCarousel: function () {
      if (this.carousel && typeof this.carousel.destroy === 'function') {
        this.carousel.destroy(true, true);
      }
      this.carousel = null;
    },

    onUnload: function () {
      this._destroyCarousel();
      if (this._resizeHandler) {
        window.removeEventListener('resize', this._resizeHandler);
        this._resizeHandler = null;
      }
      if (this.animateListSlider != null && typeof this.animateListSlider.destroy === 'function') {
        this.animateListSlider.destroy();
      }
      if (this.events && this.events.length) {
        this.events.forEach(function (unsubscribe) {
          if (typeof unsubscribe === 'function') unsubscribe();
        });
      }
    }
  };

  register('featured-collection-carousel', sectionImpl);
  load('featured-collection-carousel');
})();
